import {
  DEFAULT_NA,
  PROFILE_ACTION_NAME,
} from './newrelic-constants';

import { getStorefront } from './newrelic-helpers';

import { nrBalance } from './profile/newrelic-micro-balance';
import { nrBenefitscore } from './profile/newrelic-micro-benefitscore';
import { nrEnrollment } from './profile/newrelic-micro-enrollment';
import { nrFfnAssociation } from './profile/newrelic-micro-ffnAssociation';
import { nrLogin } from './profile/newrelic-micro-login';
import { nrRecoverAccount } from './profile/newrelic-micro-recoverAccount';
import { nrUpgradeVoucher } from './profile/newrelic-micro-upgradeVoucher';

export const sendNewRelicEvent = (action) => {
  const eventHandlers = {
    USER_ENROLLMENT: (globalState, actionName, fullStory, metricData) => {
      nrEnrollment(
        globalState,
        actionName,
        fullStory,
        metricData
      );
    },
    FFN_ASSOCIATION_MICRO: (globalState, actionName, fullStory, metricData) => {
      nrFfnAssociation(
        globalState,
        actionName,
        fullStory,
        metricData
      );
    },
    GET_BALANCE_MICRO: (globalState, actionName, fullStory, metricData) => {
      nrBalance(
        globalState,
        actionName,
        fullStory,
        metricData
      );
    },
    RETRIEVE_BENEFITS_CORE: (globalState, actionName, fullStory, metricData) => {
      nrBenefitscore(
        globalState,
        actionName,
        fullStory,
        metricData
      );
    },
    RECOVER_ACCOUNT: (globalState, actionName, fullStory, metricData) => {
      nrRecoverAccount(
        globalState,
        actionName,
        fullStory,
        metricData
      );
    },
    UPGRADE_VOUCHER: (globalState, actionName, fullStory, metricData) => {
      nrUpgradeVoucher(
        globalState,
        actionName,
        fullStory,
        metricData
      );
    },
    USER_LOGIN: (globalState, actionName, fullStory, metricData) => {
      nrLogin(
        globalState,
        actionName,
        fullStory,
        metricData,
      );
    },
  };

  const eventHandler = eventHandlers[action?.actionType];
  if (eventHandler) {
    const globalState = action?.state;


    const storefront = getStorefront(globalState);

    const hasFSfunction = window?.FS && typeof window.FS?.getCurrentSessionURL === 'function';
    const fullStory = hasFSfunction ? window?.FS?.getCurrentSessionURL() : DEFAULT_NA;
    const rqResult = action?.result;
    const metricData = {
      action,
      rqResult,
      storefront,
      resultState: action?.resultState,
    };

    eventHandler(globalState, PROFILE_ACTION_NAME, fullStory, metricData);
  }
};
